import { Fragment, useCallback, useEffect, useState } from 'react'
import { ModalMedium } from '../../../../../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../../../baseComponents/TwinTrans'
import FormRenderer from '../../../../../../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { twinFetchPostJSON } from '../../../../../../../../../../utils/globals/data'
import { displayDateTime } from '../../../../../../../../../../utils/globals/date'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../../../../../utils/reducers/getters'
import { TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import { QuoteOrderModelType } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { ButtonPrimary } from '../../../../../../../../../../baseComponents/Button'
import location from '../../../../../../../../../../utils/globals/locations'
import LoadingSpinner from '../../../../../../../../../../baseComponents/LoaderDecider/LoadingSpinner'
import { Link } from 'react-router-dom'
import PermissionChecker from '../../../../../../../../../../baseComponents/PermissionChecker'
import { CustomCustomerRenderWithLabel } from '../../../../../../../../../../specificComponents/Customers/Subcomponents'
import useQuoteStatus from '../../../../../../../../../../utils/hooks/quotes/useQuoteStatus'

interface ModalAdminAskForChangesQuoteProps extends ModalAdminAskForChangesQuoteLogicProps {
}

const ModalAdminAskForChangesQuote: React.FC<ModalAdminAskForChangesQuoteProps> = ({ setOpened, allRowData, onSubmit }) => {
    const { t } = useTwinTranslation()
    const parsedExtraData = JSON.parse(allRowData?.extraData)
    const { data } = useModalAdminAskForChangesQuoteLogic({ allRowData, setOpened, onSubmit })
    const { quoteStatus } = useQuoteStatus()

    const userPermission = getUserPermissions('quote.order')
    if (userPermission) {
        let renderThis: JSX.Element = <LoadingSpinner />
        if (data) {
            const fields: FormRender<TwinDictionary> = [
                {
                    cols: 2,
                    elements: [
                        {
                            name: 'full_assigned_number',
                            component: 'TextField',
                            label: t('quoteN', 'Nº presupuesto'),
                            value: data?.full_assigned_number,
                        },
                        {
                            name: 'CustomerId',
                            component: 'Custom',
                            render: () => <CustomCustomerRenderWithLabel label={t('customer', 'Cliente')} allRowData={{ Customer: data?.Customer }} />,
                        },
                        {
                            name: 'status',
                            component: 'TextField',
                            label: t('status', 'Estado'),
                            value: quoteStatus[data?.status]
                        },
                        {
                            name: 'processedDate',
                            component: 'TextField',
                            label: t('createdDate', 'Fecha de creación'),
                            value: displayDateTime(new Date(parsedExtraData?.processedDate))
                        },
                        {
                            name: 'message',
                            component: 'TextField',
                            label: t('mensaje', 'Mensaje'),
                            className: 'break-all',
                            value: parsedExtraData?.comment,
                        }
                    ]
                },
            ]
            renderThis = (
                <Fragment>
                    <div className='mb-25 flex flex-col gap-y-10'>
                        <h2><TwinTrans transKey='notificationInfo'>Información de la notificación</TwinTrans></h2>
                    </div>
                    <div className={'flex flex-auto flex-col h-1'}>
                        <div className='overflow-auto flex flex-col notFlexAutoFormRender'>
                            <FormRenderer sections={fields} className='grid_mincontent' />
                        </div>
                        <div className='flex w-full justify-end mt-auto'>
                            <Link to={location?.quoteOrderSingle + '/' + data?.id}>
                                <ButtonPrimary>Ir al presupuesto</ButtonPrimary>
                            </Link>
                        </div>
                    </div>
                </Fragment>
            )
        }
        return (
            <PermissionChecker userPermissions={userPermission} permission={'read'}>
                <ModalMedium opened={true} setOpened={setOpened} className={'flex flex-col'}>
                    {renderThis}
                </ModalMedium>
            </PermissionChecker>
        )
    }
    return null
}

interface ModalAdminAskForChangesQuoteLogicProps extends ModalEditComponentProps{
}

const useModalAdminAskForChangesQuoteLogic = ({ allRowData }: ModalAdminAskForChangesQuoteLogicProps) => {
    const [data, setData] = useState<QuoteOrderModelType | null>(null)
    const getQuoteOrderData = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/order/quote/getQuoteOrderComplete', { id: allRowData?.SubId })
        if (result) {
            setData(result.header)
        }
    }, [setData, allRowData?.SubId ])

    useEffect(() => {
        getQuoteOrderData()
    }, [getQuoteOrderData])

    return { data }
}

export default ModalAdminAskForChangesQuote